export default function PHP_libxml_disable_entity_loader() {
  return (
    <div>
      <h1>PHP_libxml_disable_entity_loader</h1>
    </div>
  );
}
